import React from 'react';
import {
  ChatRequestModalOverlay,
  ChatRequestModalContent,
  ChatRequestModalHeader,
  ChatRequestModalTitle,
  ChatRequestModalCloseButton,
  ChatRequestModalButtons,
  ChatRequestModalButton,
  DeleteChatModalDescription,
  DeleteChatOptionsContainer,
  DeleteChatOptionButton,
  DeleteChatOptionTitle,
  DeleteChatOptionDescription,
} from '../../../styles/UserWorkspacePageStyles';
import { useT } from '../../../LocaleContext';

const DeleteChatModal = ({
  isOpen,
  onClose,
  chatToDelete,
  onDeleteForMe,
  onDeleteForEveryone,
}) => {
  const t = useT();

  if (!isOpen || !chatToDelete) return null;

  const isGroup = chatToDelete.chat_type === 'group';
  const displayName = isGroup
    ? (chatToDelete.title || t('chat.group'))
    : chatToDelete.peer_name;
  const isCreator = Boolean(chatToDelete.is_creator);

  const title = isGroup ? t('modals.deleteGroup') : t('modals.deleteChat');
  const showDeleteForMe = !isGroup || !isCreator;
  const showDeleteForEveryone = !isGroup || isCreator;

  return (
    <ChatRequestModalOverlay onClick={onClose}>
      <ChatRequestModalContent onClick={(e) => e.stopPropagation()}>
        <ChatRequestModalHeader>
          <ChatRequestModalTitle>{title}</ChatRequestModalTitle>
          <ChatRequestModalCloseButton onClick={onClose}>
            ×
          </ChatRequestModalCloseButton>
        </ChatRequestModalHeader>
        <div style={{ marginBottom: '10px' }}>
          <DeleteChatModalDescription>
            {isGroup ? (
              <>select action for group <strong>{displayName}</strong>:</>
            ) : (
              <>select deletion type for chat with <strong>{displayName}</strong>:</>
            )}
          </DeleteChatModalDescription>
          <DeleteChatOptionsContainer>
            {showDeleteForMe && (
              <DeleteChatOptionButton onClick={onDeleteForMe} isDanger={false}>
                <DeleteChatOptionTitle>
                  {isGroup ? t('modals.leaveGroup') : t('modals.onlyForMe')}
                </DeleteChatOptionTitle>
                <DeleteChatOptionDescription isDanger={false}>
                  {isGroup
                    ? 'you will leave this group. other members will keep the group'
                    : 'chat will be deleted only for you. other participant will continue to see the chat'}
                </DeleteChatOptionDescription>
              </DeleteChatOptionButton>
            )}
            {showDeleteForEveryone && (
              <DeleteChatOptionButton onClick={onDeleteForEveryone} isDanger={true}>
                <DeleteChatOptionTitle>
                  {isGroup ? t('modals.deleteGroupEveryone') : t('modals.forEveryone')}
                </DeleteChatOptionTitle>
                <DeleteChatOptionDescription isDanger={true}>
                  {isGroup
                    ? 'the group will be deleted for all members. this action cannot be undone'
                    : 'chat will be deleted for everyone. this action cannot be undone'}
                </DeleteChatOptionDescription>
              </DeleteChatOptionButton>
            )}
          </DeleteChatOptionsContainer>
        </div>
        <ChatRequestModalButtons>
          <ChatRequestModalButton onClick={onClose}>
            {t('common.cancel')}
          </ChatRequestModalButton>
        </ChatRequestModalButtons>
      </ChatRequestModalContent>
    </ChatRequestModalOverlay>
  );
};

export default DeleteChatModal;
